import { createContext } from 'react';
const DataViewContext = createContext();
export default DataViewContext;
